function wishlist(state = {}, action) {
  switch (action.type) {
    case 'SET_WISHLIST_DATA':
      // return {...state, ...action.cart};
      return { ...action.cart };

    case 'SHOW_WISHLIST_DIALOG_MSITE':
      return { ...state, visibility: action.visibility };

    case 'HIDE_WISHLIST_DIALOG_MSITE':
      return { ...state, visibility: action.visibility };
    case 'WISHLIST_DATA':
      return {
        ...state,
        wishlistData: action.response.products,
        wishlistPriceRevealData: {
          saleStartTime: action.response.saleStartTime,
          saleEndTime: action.response.saleEndTime
        }
      };
      case 'SET_WISHLIST_NOTIFY':
        console.log("reducer fired")
        return {
          ...state,
          wishlistNotify: action.payload, 
        };
    default:
      return state;
  }
}

export default wishlist;
